var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4688 0C13.6685 0 0 13.6685 0 30.4688C0 47.269 13.6685 60.9375 30.4688 60.9375C47.269 60.9375 60.9375 47.269 60.9375 30.4688C60.9375 13.6685 47.269 0 30.4688 0ZM41.4214 31.8311L24.6563 41.959C24.4159 42.103 24.1417 42.1804 23.8616 42.1834C23.5814 42.1864 23.3056 42.1148 23.0622 41.976C22.8189 41.8372 22.6169 41.6362 22.4769 41.3935C22.3369 41.1509 22.264 40.8753 22.2656 40.5952V20.3423C22.264 20.0622 22.3369 19.7866 22.4769 19.544C22.6169 19.3014 22.8189 19.1003 23.0622 18.9615C23.3056 18.8227 23.5814 18.7511 23.8616 18.7541C24.1417 18.7571 24.4159 18.8345 24.6563 18.9785L41.4214 29.1064C41.6551 29.2488 41.8482 29.4489 41.9822 29.6875C42.1162 29.9261 42.1866 30.1951 42.1866 30.4688C42.1866 30.7424 42.1162 31.0114 41.9822 31.25C41.8482 31.4886 41.6551 31.6887 41.4214 31.8311Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6f88afd1a1224e6005faf7e84d629832.svg";
export { ForwardRef as ReactComponent };